var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-grid gap-2"},[_c('button',{class:_vm.styling,attrs:{"type":"button","data-bs-toggle":"modal","data-bs-target":"#endVotingModal"}},[_vm._v("\n        End voting\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }